export const PLATFORM_ENDPOINTS = {
    ANONYMOUS: "GetTokenBySiteId"
};
export const SEAMLESS_ENDPOINTS = {
    ANONYMOUS: "anonymous",
    LOGIN: "login",
    RENEW: "renew",
    LOGOUT: "logout"
};
export const WALLET_ENDPOINTS = {
    ANONYMOUS: "users/anonymous",
    LOGIN: "users/login",
    RENEW: "users/renew"
};
//# sourceMappingURL=requestService.js.map